import { MDText } from 'i18n-react';

import { ArrowFullRightIcon, Button } from '@motorway/mw-highway-code';

import thumbUpVideoMp4 from '../../../../../../../client/assets_seller/videos/motorway-thumb.mp4';
import thumbUpVideoWebm from '../../../../../../../client/assets_seller/videos/motorway-thumb.webm';

import LocalTexts from './WaiverModal.texts.json';

import styles from './WaiverModal.scss';

const LocalT = new MDText(LocalTexts);

type WaiverModalProps = {
  onContinue: () => void;
};

export const WaiverModal = ({ onContinue }: WaiverModalProps) => (
  <div className={styles.container}>
    <p className={styles.heading}>{LocalT.translate('heading')}</p>
    <p data-thc-style-override className={styles.body}>{LocalT.translate('body')}</p>
    <div className={styles.imageContainer}>
      <video autoPlay loop muted playsInline preload="auto" width="327px">
        <source src={thumbUpVideoWebm} type="video/webm" />
        <source src={thumbUpVideoMp4} type="video/mp4" />
      </video>
    </div>
    <div className={styles.buttonContainer}>
      <Button fullWidth icon={ArrowFullRightIcon} label={LocalT.translate('button')} onClick={onContinue} />
    </div>
  </div>
);
